import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import { formatCount, formatDuration, typeLabels } from "@/lib/content";

const TYPE_BADGE_STYLE: Record<string, string> = {
  video: "bg-primary-500 text-background-50",
  joke: "bg-accent-500 text-background-50",
  interview: "bg-secondary-500 text-background-50",
};

export default function ContentCard({ item }: { item: ContentItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full h-44 overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - ${typeLabels[item.type]}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${TYPE_BADGE_STYLE[item.type]}`}
        >
          {typeLabels[item.type]}
        </span>
        {item.type === "video" && item.duration > 0 && (
          <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs">
            {formatDuration(item.duration)}
          </span>
        )}
      </div>

      <div className="flex flex-col gap-2 p-4 md:p-5">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 hidden sm:block">
          {item.summary}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500 pt-1">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatCount(item.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-3-line" />
            {formatCount(item.likes)}
          </span>
          <span className="whitespace-nowrap">{item.date}</span>
        </div>
      </div>
    </Link>
  );
}